import {
  IResponseCourseDetail,
  IResponseCourseList,
  ICourseDetail,
  ICourseListItem
} from '@/interface/course'
import { IBannerListItem } from '@/interface'
import { ITopicDetail } from '@/interface/nonCertification'

interface CategoryFilterItem {
  id: number
  name: string
  type: string
}

const state = {
  list: {} as IResponseCourseList,
  detail: {} as IResponseCourseDetail,
  topicDetail: {} as ITopicDetail,
  banner: {} as IBannerListItem,
  playerRate: 1,
  dataList: {} as { rows: ICourseListItem[], total: number },
  categoryFilters: [] as CategoryFilterItem[]
}

export type CourseState = typeof state

const courseStore = {
  namespaced: true,
  state,
  mutations: {
    setCourseList (state: CourseState, data = {} as IResponseCourseList): void {
      state.list = data
    },
    setDataList (state: CourseState, data = {} as { rows: ICourseListItem[], total: number }): void {
      state.dataList = data
    },
    setBanner (state: CourseState, data: IBannerListItem): void {
      state.banner = data
    },
    setCategoryFilters (state: CourseState, data: CategoryFilterItem[]): void {
      state.categoryFilters = data
    },
    setCourseDetail (state: CourseState, data = {} as IResponseCourseDetail): void {
      state.detail = data
    },
    setPlayerRate (state: CourseState, rate: number) {
      state.playerRate = rate
    },
    setTopicDetail (state: CourseState, data: ITopicDetail) {
      state.topicDetail = data
    },
    updateCourseDetail (state: CourseState, data: Partial<ICourseDetail>) {
      const newValue = Object.assign({}, state.detail.courseDetail, data)
      state.detail.courseDetail = newValue
    }
  }
}

export {
  courseStore
}
